"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightListInfo = void 0;
const react_1 = __importDefault(require("react"));
const tariffGroupMapper_1 = require("../../../TariffsTable/tariffGroupMapper");
const Allotments_1 = require("./components/Allotments");
const FlightInformation_1 = require("./components/FlightInformation");
const Notes_1 = require("./components/Notes");
const Profitability_1 = require("./components/Profitability");
const SeatReservations_1 = require("./components/SeatReservations");
const FlightListInfo = (props) => {
    const { flight, flightBookingInfoBusiness, flightBookingInfoEconomy, flightTurnoverInfo, tariffGroupList, allotmentHidden, turnoverHidden, } = props;
    const economyTariffGroup = tariffGroupList.find(tariffGroup => (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup.id) === 'economy');
    const businessTariffGroup = tariffGroupList.find(tariffGroup => (0, tariffGroupMapper_1.mapTariffGroupIdToCode)(tariffGroup.id) === 'business');
    const hideProfitability = !flightTurnoverInfo || !economyTariffGroup || !businessTariffGroup;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(FlightInformation_1.FlightInformation, { flight: flight }),
        react_1.default.createElement(SeatReservations_1.SeatReservations, { business: flightBookingInfoBusiness, economy: flightBookingInfoEconomy }),
        !hideProfitability && (react_1.default.createElement(Profitability_1.Profitability, { flightTurnoverInfo: flightTurnoverInfo, economyTariffGroup: economyTariffGroup, businessTariffGroup: businessTariffGroup, turnoverHidden: !turnoverHidden })),
        react_1.default.createElement(Allotments_1.Allotments, { flightAllotments: flight.allotments, allotmentHidden: allotmentHidden }),
        react_1.default.createElement(Notes_1.Notes, { flight: flight })));
};
exports.FlightListInfo = FlightListInfo;
//# sourceMappingURL=index.js.map